import {
    GetMaskDataUsingGetParams,
    OpFinanceQueryDto,
    FeeBillDetailExportUsingGetParams,
    InvoiceQueryVo,
    Invoice,
    InvoiceData,
    InvoiceApplyVo,
    InvoiceSimpleVo,
    InvoiceQueryVo1,
    ImportUpdateUsingGetParams,
    QueryBankTradeUsingGetParams,
    OpAmountRiskRatioDto,
    OpAutoPayAmountLimitDto,
    OpAmountRiskLimitDto,
    QueryPayOrderNosByBusinessNoUsingGetParams,
    RefundConfirmDetailVo,
    RefundReturnVo,
    RefundResultVo,
    MerchantRegisterVo,
    OpPayDetailStatisticsVo,
    RefundDestinationVo,
    QueryBalancePayFailResultUsingGetParams,
    BalancePayFailResultVo,
    OpDailyTotalAmountLimitDto,
    OnlineRefundFlagVo,
    OpDailyPairAmountLimitDto,
    MerchantAuthInfo,
    MerchantAuthVo,
    CreateLoginQrCodeUsingGetParams,
    QrCodeVo,
    RefundConfirmQueryDto,
    MerchantOpenVo,
    QueryMerchantTransferInfoUsingGetParams,
    MerchantTransferVo,
    MerchantBalanceUsingGetParams,
    MerchantBalanceVo,
    UnifiedCreateOrderDto,
    UnifiedCreateOrderVo,
    CreatePrepayOrderVo
} from '@servicesTypings/payRequest'
import { SERVICE_PAY_TYPE } from '@/modules/onlinePayment/components/AuditOrderPayResultModal/typing'
import { payRequest, drpRequest } from '@/utils/request'

// providerCoId  供应商公司编号：空值的情况默认查自己
interface GetCoIsOpenPayParams {
    providerCoId?: string
}

export const getCoIsOpenPay = (params?: GetCoIsOpenPayParams): Promise<API.RootObject<MerchantOpenVo>> => {
    return payRequest.get('/merchant/isOpen', {
        params
    })
}

interface GetCoIsOpenRefundParams {
    channelCoId?: string
}

interface GetCoIsOpenRefundRes {
    channelCoId: string // 分销商coId
    channelName: string // 分销商商家名称
    rechargeBalance: number // 分销商充值余额
    refundableAmount: number // 分销商可在线退款金额
}
export const queryRefundableAmount = (
    params?: GetCoIsOpenRefundParams
): Promise<API.RootObject<GetCoIsOpenRefundRes>> => {
    return payRequest.get('/refund/queryRefundableAmount', {
        params
    })
}

interface BatchQueryOnlinePayInfo {
    supplierCoIds: string[]
}

export const batchQueryOnlinePayInfo = (data?: BatchQueryOnlinePayInfo): Promise<API.RootObject<MerchantOpenVo[]>> => {
    return drpRequest.post('/merchant/batchQueryOnlinePayInfo', {
        data
    })
}

export interface QueryBalancePayProgressRes {
    curProcess: number
    finished: boolean
    total: number
    actualAmount: number
    feeAmount: number
}

export const queryBalancePayProgress = (params: {
    batchNo: string
}): Promise<API.RootObject<QueryBalancePayProgressRes>> => {
    return payRequest.get('/balance/pay/queryBalancePayProgress', {
        params
    })
}

export interface GetCoRestBalanceRes {
    coId?: string
    merchantId?: string
    payable?: string
}

interface GetCoRestBalanceParams {
    merchantId: string
}

export const getCoRestBalance = (params?: GetCoRestBalanceParams): Promise<API.RootObject<GetCoRestBalanceRes>> => {
    return payRequest.get('/merchant/merchantBalance', { params })
}

export interface GetGetCoMerchantListResItem {
    coId?: string
    merchantId?: string
    outMerchantId?: string
    alias?: string
    merchantType?: string
    isDefault?: boolean
}

type GetGetCoMerchantListRes = GetGetCoMerchantListResItem[]

export const getCoMerchantList = (): Promise<API.RootObject<GetGetCoMerchantListRes>> => {
    return payRequest.get('/merchant/list')
}

export type CreatePayOrderDataModule =
    | 'SAMPLE_CART'
    | 'PUSH_ORDER_RECHARGE'
    | 'PUSH_ORDER_BILL'
    | 'TECH_SERVICE_FEE_BILL'
    | 'DIRECT_RECHARGE'
    | 'MY_SUPPLIER'
    | 'DIS_FUND_DETAIL'
    | 'DIS_SETTLEMENT'
    | 'DIS_MOBILE_RECHARGE'

export interface CreatePayOrderDataLog {
    channel: 'ERP' | 'GYL' | 'JHT' | 'EPAAS'
    module: CreatePayOrderDataModule
    // SAMPLE_CART                          采样车
    // PUSH_ORDER_RECHARGE     订单推单-充值
    // PUSH_ORDER_BILL                  订单推单-支付账单
    // TECH_SERVICE_FEE_BILL      技术服务费账单-支付账单
    // DIRECT_RECHARGE                 订单余额不足供应商
    // MY_SUPPLIER                           我的供应商
    // DIS_FUND_DETAIL                    分销资金明细
    // DIS_SETTLEMENT               分销结算
    // DIS_MOBILE_RECHARGE          分销小站-充值
}

interface CreateOrderItem {
    /** 收款方公司编号 */
    payeeCoId: string
    /**
     * 订单总金额
     */
    totalAmount: number | string
    /**
     * 用于后端 实现原路在线退款
     */
    businessBatchNo: string
}

interface CreateMergePayOrderData extends CreatePayOrderDataLog {
    payeesInfo: Omit<CreateOrderItem, 'businessBatchNo'>[]
    businessBatchNo: CreateOrderItem['businessBatchNo']
}

export const createMergerPayOrder = (data: CreateMergePayOrderData): Promise<API.RootObject<CreatePayOrderRes>> => {
    return drpRequest.post('/funds/createMergePayOrder', { data })
}

export interface CreatePayOrderRes {
    // 网商订单号
    orderNo: string
    tradeNo: string
    // 外部流水号
    outTradeNo: string
    /** 是否显示提示文案（部分供应商因账户异常导致发起支付失败，请您先支付其他供应商） */
    partialFailFlag?: boolean
}

type CreatePayOrderItemWithLog = CreatePayOrderDataLog & CreateOrderItem

export const createPayOrder = (data: CreatePayOrderItemWithLog): Promise<API.RootObject<CreatePayOrderRes>> => {
    return drpRequest.post('/funds/createPayOrderV2', { data })
}

export interface createBatchPayOrderRes {
    /**
     * 批次号
     */
    batchNo: string
    // 后面还有很多，前端用不到，就忽略了
}

export const createBatchPayOrder = (
    data: CreatePayOrderItemWithLog[]
): Promise<API.RootObject<createBatchPayOrderRes>> => {
    return drpRequest.post('/funds/createBatchPayOrder', { data })
}

export interface prePayCreatePayOrderRes {
    batchNo: number
    // createPayType: ''
    orderNo: string
    // orderPayUrl:
    outTradeNo: string
    payMode: string
    splitFlag: boolean
    tradeNo: number
}
export const prePayCreatePayOrder = (
    data: { batchNo: string; createPayType: SERVICE_PAY_TYPE } & CreatePayOrderDataLog
): Promise<API.RootObject<prePayCreatePayOrderRes>> => {
    return payRequest.post('/prePay/createPayOrder', { data })
}

interface BaseReqDate {
    /**
     * @description    页码
     */
    pageNum?: number
    /**
     * @description    分页条数
     */
    pageSize?: number
}

interface MerchantReqDate extends BaseReqDate {
    /**
     * @description    商家名称
     */
    coName?: string
    /**
     * @description    商家编号
     */
    coId?: string
    /**
     * @description    商户号
     */
    merchantId?: string
    /**
     * @description    外部商户号
     */
    outMerchantId?: string
    /**
     * @description    开始时间：yyyy-MM-dd
     */
    startTime?: string
    /**
     * @description    结束时间：yyyy-MM-dd
     */
    endTime?: string
}

interface MerchantResDate {
    /**
     * @description    公司编号
     */
    coId?: string
    /**
     * @description    公司名称
     */
    coName?: string
    /**
     * @description    商户号
     */
    merchantId?: string
    /**
     * @description    外部商户号
     */
    outMerchantId?: string
    /**
     * @description    商户类型
     */
    merchantType?: string
    /**
     * @description    商户简称
     */
    alias?: string
    /**
     * @description    联系人手机号
     */
    mobile?: string
    /**
     * @description    联系人姓名
     */
    contact?: string
    /**
     * @description    企业法人
     */
    legalPerson?: string
    /**
     * @description    负责人
     */
    principal?: string
}

// 查询商家网商银行账户 (中台使用)
export const getMerchantList = (data: MerchantReqDate): Promise<API.RootObject<MerchantResDate>> => {
    return payRequest.post('/op/merchant/list', { data })
}

interface MerchantBaseDate {
    /**
     * @description    公司编号
     */
    coId?: string
    /**
     * @description    商户号
     */
    merchantId?: string
}

interface MerchantBalanceResDate extends MerchantBaseDate {
    /**
     * @description    可支付金额
     */
    payable: bigint
}

// 查询商家开通的网商银行账号的余额信息 (中台使用)
export const queryMerchantBalance = (data: MerchantBaseDate): Promise<API.RootObject<MerchantBalanceResDate>> => {
    return payRequest.post('/op/merchant/balance', { data })
}
// 解绑商户 (中台使用)
export const unbindMerchant = (data: MerchantBaseDate): Promise<API.RootObject<boolean>> => {
    return payRequest.post('/op/merchant/unbind', { data })
}
// 冻结商户 (中台使用)
export const frozenMerchant = (data: MerchantBaseDate): Promise<API.RootObject<boolean>> => {
    return payRequest.post('/op/merchant/frozen', { data })
}

// 查看商家日志
export const getMerchantLog = (params: { pageNum: number; pageSize: number; coId: string }) => {
    return payRequest.get('/op/merchant/log', { params })
}

interface PayOrderReqDate extends BaseReqDate {
    /**
     * @description    商家名称
     */
    coName?: string
    /**
     * @description    商家编号
     */
    coId?: string
    /**
     * @description    商户号
     */
    merchantId?: string
    /**
     * @description    外部商户号
     */
    outMerchantId?: string
    /**
     * @description    网商订单号
     */
    orderNo?: string
    /**
     * @description    支付单状态：DEALING-待支付，CLOSE-订单关闭，SUCCESS-支付成功，FAIL-订单失败
     */
    status?: 'DEALING' | 'CLOSE' | 'SUCCESS' | 'FAIL'
}

interface PayOrderResDate {
    /**
     * @description    公司编号
     */
    coId?: string
    /**
     * @description    公司名称
     */
    coName?: string
    /**
     * @description    商户号
     */
    merchantId?: string
    /**
     * @description    网商订单号
     */
    orderNo?: string
    /**
     * @description    业务交易号
     */
    tradeNo?: string
    /**
     * @description    外部流水号
     */
    outTradeNo?: string
    /**
     * @description    状态
     */
    status?: string
    /**
     * @description    订单总金额
     */
    totalAmount?: bigint
    /**
     * @description    收款方公司名称
     */
    payeeCoName?: string
    /**
     * @description    付款方公司名称
     */
    payerCoName?: string
}

// 查询商家支付订单明细 (中台使用)
export const getPayOrderList = (data: PayOrderReqDate): Promise<API.RootObject<PayOrderResDate>> => {
    return payRequest.post('/op/order/list', { data })
}

// 查询支付订单金额总计 (中台使用)
export const getPayOrderSummary = (data: PayOrderReqDate): Promise<API.RootObject<PayOrderResDate>> => {
    return payRequest.post('/op/order/summary/total', { data })
}

export interface QueryRefundInfoReq {
    oidList?: string[]
    payBatchNo?: string
    /**
     * 退款批次号
     */
    refundTradeNo?: string
}

export interface QueryRefundInfoRes {
    refundAmount: number
    refundFeeAmount: number
    /**
     * 退款订单数量
     */
    refundOrderCount: number
    /**
     * 总退款金额
     */
    totalRefundAmount: number
}
// 按批次号或者订单号查询退款金额
export const queryRefundInfo = (data: QueryRefundInfoReq): Promise<API.RootObject<QueryRefundInfoRes>> => {
    return payRequest.post('/prePay/queryRefundInfo', { data })
}

interface PayBaseMessageDate {
    /**
     * @description    公司编号
     */
    coId?: string
    /**
     * @description    网商订单号
     */
    orderNo?: string
    /**
     * @description    业务交易号
     */
    tradeNo?: string
    /**
     * @description    外部流水号
     */
    outTradeNo?: string
}

// 手工同步支付订单状态信息 (中台使用)
export const syncPayStatus = (data: PayBaseMessageDate): Promise<API.RootObject<boolean>> => {
    return payRequest.post('/op/order/sync', { data })
}

// 主动退出二维码关单或退款
export function closeOrRefund(data: {
    /**
     * 批次号-支付的
     */
    batchNo: number
}) {
    return payRequest.post('/prePay/closeOrRefund', { data })
}

// 手工推送支付记录信息 (中台使用)
export const pushPayOrderRecord = (data: PayBaseMessageDate): Promise<API.RootObject<boolean>> => {
    return payRequest.post('/op/order/push', { data })
}
// 手工推送推送分账
export const pushPayShareOrder = (data: PayBaseMessageDate): Promise<API.RootObject<Record<string, any>>> => {
    return payRequest.post('/op/order/share/push', { data })
}
// 手工推送推送分账
export const queryOrderShareList = (data: PayBaseMessageDate): Promise<API.RootObject<Record<string, any>>> => {
    return payRequest.post('/op/order/share/list', { data })
}
// 导出支付单明细 (中台使用)
export const exportOrderRecord = (data: PayOrderReqDate): Promise<API.RootObject<unknown>> => {
    return payRequest.post('/op/order/exportPayOrder', { data })
}
// 手工关闭支付订单 (中台使用)
export const payOrderClose = (data: PayBaseMessageDate): Promise<API.RootObject<boolean>> => {
    return payRequest.post('/op/order/close', { data })
}

// 查询枚举值列表
export const getEnumList = (params: {
    type: string
}): Promise<API.RootObject<Array<{ type: string; list: Array<{ code: string; name: string }> }>>> => {
    return payRequest.get('/basic/getEnumList', { params })
}
/**
 * 获取加密数据
 */
export function getMaskData(params: GetMaskDataUsingGetParams): API.Res<object> {
    return payRequest.get('/op/merchant/getMaskData', { params })
}

// 按月查询技术服务费
/**
 * 查询技术服务费统计 (转换包含中文无法完全转换)
 */
export function getFeeStatistics(data: OpFinanceQueryDto): API.Res<any[]> {
    return payRequest.post('/op/finance/fee/statistics', { data })
}

// 查询技术服务费明细
/**
 * 查询技术服务费统计明细 (转换包含中文无法完全转换)
 */
export function getFeeDetail(data: OpFinanceQueryDto): API.Res<any[]> {
    return payRequest.post('/op/finance/fee/detail', { data })
}

// 技术服务费明细导出
/**
 * 导出技术服务费统计明细
 */
export function exportFeeStatistics(params: FeeBillDetailExportUsingGetParams): API.Res<any> {
    return payRequest.get('/op/finance/fee/export', { params })
}

// 分页查询支付发票表列表
/**
 * 查询支付发票表列表
 */
export function getPayInvoiceList(data: InvoiceQueryVo): API.Res<Invoice[]> {
    return payRequest.post('/payInvoice/list', { data })
}

// 查询待开票的单据
/**
 * 查询待开票的单据
 */
export function getWaitPayInvoiceList(data: InvoiceQueryVo): API.Res<InvoiceData[]> {
    return payRequest.post('/payInvoice/wait/list', { data })
}

// 提交申请开票发票详情
/**
 * 查询申请开票发票详情
 */
export function pushPayInvoiceApply(data: InvoiceApplyVo): API.Res<boolean> {
    return payRequest.post('/payInvoice/apply', { data })
}

// 查询申请开票发票详情用于填充
/**
 * 查询申请开票发票详情用于填充
 */
export function getInvoiceApplyInfo(): API.Res<InvoiceSimpleVo> {
    return payRequest.get('/payInvoice/apply/fill')
}

// 分页查询支付发票表列表 - 中台
/**
 * 查询支付发票表列表
 */
export function getOpPayInvoiceList(data: InvoiceQueryVo1): API.Res<Invoice[]> {
    return payRequest.post('/op/payInvoice/list', { data })
}

// 导出支付发票表列表 - 中台
/**
 * 导出
 */
export function exportOpPayInvoiceList(data: InvoiceQueryVo1): API.Res<string> {
    return payRequest.post('/op/payInvoice/export', { data })
}

// 导入更新开票信息 - 中台
/**
 * 导入更新开票信息
 */
export function importUpdateOpPayInvoiceList(params: ImportUpdateUsingGetParams): API.Res<string> {
    return payRequest.get('/op/payInvoice/importUpdate', { params })
}

// 网商交易查询 - 内嵌epaas服务
/**
 * 网商交易查询 (转换包含中文无法完全转换)
 */
export function queryTrade(params: QueryBankTradeUsingGetParams): API.Res<any[]> {
    return payRequest.get('/order/queryTrade', { params })
}

// 设置大额风控比例
/**
 * 设置大额风控比例
 */
export function setAmountRiskRatio(data: OpAmountRiskRatioDto): API.Res<boolean> {
    return payRequest.post('/op/merchant/setAmountRiskRatio', { data })
}

// 设置设置余额免密支付金额限制
/**
 * 设置免密支付金额限制
 */
export function setAutoPayAmountLimit(data: OpAutoPayAmountLimitDto): API.Res<boolean> {
    return payRequest.post('/op/merchant/setAutoPayAmountLimit', { data })
}

// 设置聚货通单月收款额度
/**
 * 设置聚货通单月收款额度
 */
export function setAmountRiskLimit(data: OpAmountRiskLimitDto): API.Res<boolean> {
    return payRequest.post('/op/merchant/setAmountRiskLimit', { data })
}

/** 查询二次退款确认明细 */
export function queryRefundConfirmDetail(data: RefundConfirmQueryDto): API.Res<RefundConfirmDetailVo> {
    return payRequest.post('/refund/queryRefundConfirmDetail', { data })
}

/**
 * 查询业务单号对应的支付单号列表
 * @param params
 * @transferType 跳转页面类型:分销订单-DIS_ORDER，售后单-AFTER_SALE_ORDER
 * @returns
 */
/**
 * 查询业务单号对应的支付单号列表
 */
export function queryPayOrderNosByBusinessNo(params: QueryPayOrderNosByBusinessNoUsingGetParams): API.Res<string[]> {
    return payRequest.get('/finance/trade/queryPayOrderNosByBusinessNo', { params })
}

// 查询供应商分销余额在线退款结果
/**
 * 供应商分销余额在线退款
 */
export function querySupplierOrderRefund(data: RefundConfirmDetailVo): API.Res<RefundReturnVo> {
    return payRequest.post('/refund/supplierOrderRefund', { data })
}

// 查询供应商分销余额在线退款结果
/**
 * 查询供应商分销余额在线退款结果
 */
export function querySupplierOrderRefundResult(data: RefundReturnVo): API.Res<RefundResultVo> {
    return payRequest.post('/refund/querySupplierOrderRefundResult', { data })
}

// 查询当前用户是否注册中
/**
 * 查询当前用户是否注册中
 */
export function isUserRegistering(): API.Res<MerchantRegisterVo> {
    return payRequest.get('/merchant/isUserRegistering')
}

// 查询余额免密支付配置
export const queryAutoPayLowBalanceLimit = () => {
    return payRequest.get('/balance/pay/queryAutoPayLowBalanceLimit')
}

// 配置余额免密支付余额低水位告警
export const modifyAutoPayLowBalanceLimit = (data: { autoPayLowBalanceLimit: number }) => {
    return payRequest.post('/balance/pay/modifyAutoPayLowBalanceLimit', {
        data
    })
}

// 查询EPAAS服务订阅明细
/**
 * 查询EPAAS服务订阅明细
 */
export function getStatisticsDetail(data: OpFinanceQueryDto): API.Res<OpPayDetailStatisticsVo[]> {
    return payRequest.post('/op/finance/order/statisticsDetail', { data })
}

// 查询在线退款资金去向
/**
 * 查询在线退款资金去向
 */
export function queryRefundDestination(data: RefundReturnVo): API.Res<RefundDestinationVo> {
    return payRequest.post('/refund/queryRefundDestination', { data })
}

// 根据批次号查询余额免密支付失败结果
/**
 * 根据批次号查询免密支付失败结果
 */
export function queryBalancePayFailResult(
    params: QueryBalancePayFailResultUsingGetParams
): API.Res<BalancePayFailResultVo> {
    return payRequest.get('/balance/pay/queryBalancePayFailResult', { params })
}

// 生成充值/提现/明细二维码 merchantId:string
/**
 * 生成网商银行登录二维码
 */
export function payQrCodeLogin(params: CreateLoginQrCodeUsingGetParams): API.Res<QrCodeVo> {
    return payRequest.get('/qrCode/login', { params })
}

/**
 * 设置高危商家单日总收款限额
 */
/**
 * 设置高危商家单日总收款限额
 */
export function setDailyTotalAmountLimit(data: OpDailyTotalAmountLimitDto): API.Res<boolean> {
    return payRequest.post('/op/merchant/setDailyTotalAmountLimit', { data })
}

/**
 * 查询是否支持优先在线退款
 */
export const queryOnlineRefundFlag = () => {
    return payRequest.get('/refund/queryOnlineRefundFlag')
}

/**
 * 配置支持优先在线退款开关
 */
/**
 * 配置支持优先在线退款开关
 */
export function modifyOnlineRefundFlag(data: OnlineRefundFlagVo): API.Res<boolean> {
    return payRequest.post('/refund/modifyOnlineRefundFlag', { data })
}

/**
 * 设置高危商家单日关系对收款限额
 */
/**
 * 设置高危商家单日关系对收款限额
 */
export function setDailyPairAmountLimitDto(data: OpDailyPairAmountLimitDto): API.Res<boolean> {
    return payRequest.post('/op/merchant/setDailyPairAmountLimitDto', { data })
}

/**
 * 查询商家网商银行开通权限
 */
/**
 * 判断当前账号对应的网商银行开通权限【不发短信】
 */
export function payMerchantAuth(data: MerchantAuthInfo): API.Res<MerchantAuthVo> {
    return payRequest.post('/merchant/validateAuth', { data })
}
/**
 * 判断分销资金查看支付流水是否支持跳转
 */
export const payFundsTransfer = params => {
    return payRequest.get('/finance/trade/funds/transfer', { params })
}
// 查询商家网商银行开通权限 短信验证
export function payMerchantIsVerified(data, authOptions) {
    return payRequest.post('/merchant/verifyAndSms', {
        data,
        authOptions
    })
}
// 申请关闭余额免密支付
/**
 * 申请开通免密支付
 */
export function autoPayClose(data): API.Res<boolean> {
    return payRequest.post('/balance/pay/app/autoPayClose', { data })
}

/**
 * 设置忽略最低交易金额
 */
export function setIgnoreLowestTrade(data): API.Res<boolean> {
    return payRequest.post('/op/merchant/setIgnoreLowestTrade', { data })
}

/**
 * 查询商户号转账信息
 */
export function queryMerchantTransferInfoUsingGET(
    params: QueryMerchantTransferInfoUsingGetParams
): API.Res<MerchantTransferVo> {
    return payRequest.get('/merchant/queryTransferInfo', { params })
}

/**
 * 查询当前商户的余额信息
 */
export function merchantBalanceUsingGET(params: MerchantBalanceUsingGetParams): API.Res<MerchantBalanceVo> {
    return payRequest.get('/merchant/merchantBalance', { params })
}

/**
 * 统一创建支付单
 */
export function createUnifiedPayOrderUsingPOST(data: UnifiedCreateOrderDto): API.Res<UnifiedCreateOrderVo> {
    return payRequest.post('/order/create', { data })
}

/**
 * 创建支付单
 */
export function createPayOrderV2UsingPOST(data: CreatePrepayOrderVo): API.Res<UnifiedCreateOrderVo> {
    return payRequest.post('/prePay/createPayOrderV2', { data })
}
